module.exports = __webpack_public_path__ + "img/placeholder.6cfe38d0.jpg";